<template>
  <workbenchDetail
    @cancelCallBack="cancel"
    @approvalConfirm="approvalConfirm"
    :backlogModel="backlogModel"
    :isHide="isHide"
  >
    <div slot="content">
      <el-form label-width="130px" :model="dataForm">
        <el-form-item label="姓名：" prop="Name">{{
          dataForm.Name
        }}</el-form-item>
        <el-form-item label="捐献者电话：" prop="Phone">{{
          dataForm.Phone
        }}</el-form-item>
        <el-form-item label="身份证号码：" prop="IdentityCard">{{
          dataForm.IdentityCard
        }}</el-form-item>
        <el-form-item label="登记地：" prop="RegisterAddress">
          <v-region :town="true" v-model="addre" type="text"></v-region>
        </el-form-item>
        <el-form-item label="捐献意愿：" prop="Willingness">
          {{ dataForm.Willingness }}
        </el-form-item>
        <el-form-item label="登记时间:" prop="CreateTime">
          {{ (dataForm.CreateTime * 1000) | formatDate }}
        </el-form-item>
        <el-form-item label="状态：" prop="Status">
          {{ showStatus(dataForm.Status) }}
        </el-form-item>
      </el-form>
    </div>
  </workbenchDetail>
</template>
<script>
import workbenchDetail from "@/modules/zjrc/pages/workbench/common/workbenchDetail";
import api from "@/modules/zjrc/api";
import { mapGetters } from "vuex";

export default {
  name: "audit",
  props: {
    backlogModel: {
      type: Object,
      default: null,
    },
    isHide: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataForm: {}, //表单对象
      addre: {
        province: "",
        city: "",
        area: "",
        town: "",
      }, //地址
    };
  },
  components: {
    workbenchDetail,
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
    showStatus() {
      return (data) => {
        return data == 0 ? "未完成" : "已完成";
      };
    },
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  methods: {
    //初始化数据
    loadData() {
      let that = this;
      let params = { Id: that.backlogModel.BusinessId };
      api.QueryDonationOrganById(params).then((res) => {
        if (res.data.Code == 0) {
          that.dataForm = res.data.Data;
          that.checkedwillingness = that.dataForm.Willingness.split(",");
          let addrArry = that.dataForm.RegisterAddress.split(",");
          that.addre = {
            province: addrArry[0],
            city: addrArry[1],
            area: addrArry[2],
            town: addrArry[3],
          };
        }
      });
    },
    //取消
    cancel() {
      this.$emit("auditCallBack", null);
    },
    //提交数据
    approvalConfirm(data) {
      let params = Object.assign({}, data);
      api
        .AuditDonationOrgan(params)
        .then((res) => {
          if (res.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.$emit("auditCallBack", params);
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
  },
};
</script>
